export enum GroupFilter {
	ADMINISTERED = 'administered',
	INVITES = 'invites',
	MEMBER = 'member',
}

export const DEFAULT_GROUP_FILTERS = [
	GroupFilter.ADMINISTERED,
	GroupFilter.MEMBER,
];

export enum GroupSort {
	ALPHABETICAL = 'alphabetical',
	LAST_VISIT = 'last_visit',
}

export type FilterToStringMap = {
	[k in GroupFilter]: string;
};

export type SortToStringMap = {
	[k in GroupSort]: string;
};

export const sortButtonLabels: SortToStringMap = {
	[GroupSort.LAST_VISIT]: 'content.sort.last-visit',
	[GroupSort.ALPHABETICAL]: 'content.sort.alphabetical',
};

export enum GroupPageTab {
	MAIN = 'main',
	CONTENT = 'content',
	EVENTS = 'events',
	CUSTOM = 'custom',
	LMS = 'LMS',
}
